import type { Notices } from "@/lib/notices"

import { CheckCircleIcon, ChevronRightIcon, ErrorIcon } from "@/constants/icons"

type NoticeItemTheme = {
  containerClassName: React.HTMLAttributes<HTMLDivElement>[`className`]
  icon: typeof ErrorIcon
}

export const noticeItemThemes: Record<Notices.Type, NoticeItemTheme> = {
  error: {
    containerClassName: `bg-red-100 text-red-700`,
    icon: ErrorIcon,
  },
  info: {
    containerClassName: `bg-black-100 text-black-700`,
    icon: ChevronRightIcon,
  },
  success: {
    containerClassName: `bg-green-100 text-green-700`,
    icon: CheckCircleIcon,
  },
  warning: {
    containerClassName: `bg-yellow-100 text-yellow-700`,
    icon: ErrorIcon,
  },
}
